import { useState } from 'react';
import Edit from '@mui/icons-material/Edit';
import {IconButton} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import { API_BASE_URL} from "../baseURL";

const Farmer = ({ farmer, setFarmer }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [modaldata, setModaldata] = useState('');

    function saveNewComment(noteId, newComment) {
        const id = parseInt(noteId);

        fetch(`${API_BASE_URL}/farmers/notes/${id}/update-comment`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: newComment
        }).then()

        farmer.notes.find(note => note.id === id).comment = newComment;
        setFarmer(farmer);
    }

    function deleteNote(noteId) {
        const id1 = parseInt(farmer.id);
        const id2 = parseInt(noteId);

        console.log('id1 = ' + id1 + ', id2 = ' + id2);

        fetch(`${API_BASE_URL}/farmers/${id1}/notes/${id2}/delete`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
        }).then();

        farmer.notes.forEach((note, index) => {
            if(note.id === noteId) {
                farmer.notes.splice(index, 1);
            }
        })

        setFarmer({...farmer})
    }

    function saveNewNote(date, note) {
        let temp = null;
        fetch(`${API_BASE_URL}/farmers/notes/create-note`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
                },
            body: JSON.stringify({ farmerId: farmer.id, date: date, note: note })
        }).then(response => response.json())
            .then(data =>  setFarmer(data))
    }

    function saveNewNoteNew(date, note) {
        fetch(`${API_BASE_URL}/farmers/notes/create-note-new`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify({ farmerId: farmer.id, date: date, note: note })
        }).then(response => response.json())
            .then(data =>  {
                farmer.notes.push(data);
                farmer.notes.sort((a, b) => new Date(b.date) - new Date(a.date));
                setFarmer(farmer);
            })
    }

    return (
        <>
            { farmer ? (
                <div>
                    <IconButton>
                        <Add fontSize="inherit" className="custom-btn-add" onClick={() => {
                            setShowAddModal(true);
                            // setModaldata(farmer.id);
                        }} />
                    </IconButton>

                    <table className="inner-table">
                        <thead >
                            <tr >
                                <th style={{width:"10%", paddingLeft: "20px"}}>Datum</th>
                                <th style={{width:"10%"}}>Benutzer</th>
                                <th style={{width:"65%"}}>Notiz</th>
                                <th style={{width:"15%"}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            { farmer.notes && farmer.notes.map((note, index) => (
                                <tr key={index} id="rowId" value={note.id}>
                                    <td>{new Date(note.date).toLocaleDateString('sv-SE')}</td>
                                    <td>{note.user}</td>
                                    <td>{note.comment}</td>
                                    <td className="actions">
                                        <IconButton>
                                            { note.changeable ?
                                                <Edit className="custom-btn-edit"
                                                      onClick={() => {
                                                          setShowEditModal(true);
                                                          setModaldata(note);
                                                      }} /> : <Edit className="custom-btn-edit" style={{color: "grey"}} disabled/>
                                            }
                                        </IconButton>
                                        <IconButton>
                                            { note.changeable ?
                                                <DeleteIcon className="custom-btn-delete" onClick={() => { if(window.confirm("Wirklich entfernen?")) {deleteNote(note.id)} }} /> :
                                                <DeleteIcon className="custom-btn-delete" style={{color: "grey"}} disabled/>
                                            }
                                        </IconButton>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* displays edit modal  */}
                    { showEditModal ? (
                        <div className="custom-modal">
                            <div className="custom-modal-dialog">
                                <div>
                                     <button onClick={() => setShowEditModal(false)} style={{ float: "right" }}> &times; </button>
                                    {/*<h4>Nr. : {modaldata.id}</h4>*/}
                                </div>

                                <div style={{marginTop:"20px"}}>
                                    <input id="noteId" value={modaldata.id} hidden />
                                    <p>
                                        <b>Datum:</b> {new Date(modaldata.date).toISOString().split('T')[0]}
                                    </p>
                                    <textarea id="textarea" style={{width:"100%", height:"100px"}}>
                                        {modaldata.comment}
                                    </textarea>
                                </div>

                                <div style={{marginTop: "20px"}}>
                                    <button onClick={() => { setShowEditModal(false) }} className="custom-btn-close" > Schließen </button>
                                    <button
                                        onClick={() => {
                                            setShowEditModal(false)
                                            saveNewComment(document.getElementById("noteId").value, document.getElementById("textarea").value)
                                            }
                                        }
                                        className="custom-btn-save" > Speichern </button>
                                </div>
                            </div>
                        </div>
                    ) : null }

                    {/* displays add modal  */}
                    { showAddModal ? (
                        <div className="custom-modal">
                            <div className="custom-modal-dialog">
                                {/*<div className="modal-header">
                                    <h4>Nr. : {modaldata.id}</h4>
                                </div>*/}
                                <div className="custom-modal-body">
                                    {/*<input id="farmerId" value={modaldata} hidden />*/}
                                    <div>
                                        <label><b>Datum:</b></label>
                                        <br/>
                                        <input type="date" id="date" style={{width:"25%"}} />
                                    </div>
                                    <br/>
                                    <div>
                                        <label><b>Notiz:</b></label>
                                        <textarea id="note" style={{width:"100%", height:"100px"}}></textarea>
                                    </div>
                                </div>
                                <div style={{marginTop: "20px"}}>
                                    <button onClick={() => { setShowAddModal(false); }} className="custom-btn-close" > Schließen </button>
                                    <button
                                        onClick={() => {
                                            setShowAddModal(false)
                                            saveNewNoteNew(/*document.getElementById("farmerId").value,*/
                                                        document.getElementById("date").value,
                                                        document.getElementById("note").value)
                                            }
                                        }
                                        className="custom-btn-save" style={{marginLeft:"20px"}} > Speichern </button>
                                </div>
                            </div>
                        </div>
                    ) : null }
                </div>
            ) : null }
        </>
    );
}

export default Farmer;
